import { RouteComponentProps } from "react-router-dom";
import ModuleSettings from "src/Pages/Company/OrganizationStructure/ModuleSettings";
import DataManagement from "src/Pages/Company/OrganizationStructure/DataManagment";
import CreateStructure from "src/Pages/Company/OrganizationStructure/ConfigureStructure/CreateStructure";
import OrganizationStructureProviders from "src/Pages/Company/OrganizationStructure/Providers/OrganizationStructureProviders";
import SecureRoute from "src/utils/RoleBasedSecurity/SecurityComponents/SecureRoute";
import {
  organizationStructureEmployeeDataExport,
  organizationStructureModuleRead,
} from "src/utils/RoleBasedSecurity/permissions";
import OrganizationStructure from ".";

export default function OrganizationStructureRoutes({
  match,
}: RouteComponentProps) {
  return (
    <OrganizationStructureProviders>
      <SecureRoute
        permission={organizationStructureModuleRead}
        path={`${match.url}/configure-structure`}
        component={OrganizationStructure}
      />
      <SecureRoute
        permission={organizationStructureModuleRead}
        path={`${match.url}/configure-structure/create-structure`}
        component={CreateStructure}
      />
      <SecureRoute
        permission={organizationStructureEmployeeDataExport}
        path={`${match.url}/import-export-data`}
        component={DataManagement}
      />
      <SecureRoute
        permission={organizationStructureModuleRead}
        path={`${match.url}/module-settings`}
        component={ModuleSettings}
      />
    </OrganizationStructureProviders>
  );
}
